// -----------------------------------------------------------------------------
// Login
// -----------------------------------------------------------------------------

const init = () => {
  if ($('.js-body').hasClass('js-body-login') === false) {
    return;
  }
  initEventListeners();
};

/**
 * Event-Listeners einrichten
 */
const initEventListeners = () => {
  $('.js-pw-toggle').click(function (e) {
    e.preventDefault();

    var inputGroup = $(this).closest('.input-group');
    var input = inputGroup.find('input.form-control');
    var icon = inputGroup.find('i');
    // toggle field type
    input.attr('type', input.attr('type') === 'text' ? 'password' : 'text');
    // toggle icon class
    icon.toggleClass('fa-eye-slash fa-eye');
  });
};

export {
  init
};
